{
  "version": 1,
  "asset_id": "1481cc14-6a70-45d0-9a77-9db94f35221d",
  "project_id": "affbb9b7-8892-4de7-a6a3-a24f8c559459",
  "url": "/__l5e/assets-v1/1481cc14-6a70-45d0-9a77-9db94f35221d/libera4.webp",
  "r2_key": "a/v1/affbb9b7-8892-4de7-a6a3-a24f8c559459/1481cc14-6a70-45d0-9a77-9db94f35221d/libera4.webp",
  "original_filename": "libera4.webp",
  "size": 81768,
  "content_type": "image/webp",
  "created_at": "2026-08-07T09:36:53Z"
}
